import React from 'react';

import styles from './ArticleLoader.module.scss';

const ArticleLoader = ({ index }) => {
  return (
    <div id={`loader_${index}`} className={styles['article__loader']}>
      <div className={styles['article__loader--avatar']} />
      <div className={styles['article__loader--content']}>
        <div className={styles['content__title']} />
        <div className={styles['content__info']} />
      </div>
    </div>
  );
};

export default ArticleLoader;
